export { default } from './SearchAccueil.container'
